import { render, staticRenderFns } from "./ourCatalogueList.vue?vue&type=template&id=268635c1&scoped=true&"
import script from "./ourCatalogueList.vue?vue&type=script&lang=js&"
export * from "./ourCatalogueList.vue?vue&type=script&lang=js&"
import style0 from "./ourCatalogueList.vue?vue&type=style&index=0&id=268635c1&scoped=true&lang=css&"
import style1 from "./ourCatalogueList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268635c1",
  null
  
)

export default component.exports